export const fabricConstants = {
  GET_SINGLE_REQUEST: "FABRIC_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "FABRIC_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "FABRIC_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "FABRIC_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "FABRIC_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "FABRIC_GET_ALL_FAILURE",

  ADD_REQUEST: "FABRIC_ADD_REQUEST",
  ADD_SUCCESS: "FABRIC_ADD_SUCCESS",
  ADD_FAILURE: "FABRIC_ADD_FAILURE",

  UPDATE_REQUEST: "FABRIC_UPDATE_REQUEST",
  UPDATE_SUCCESS: "FABRIC_UPDATE_SUCCESS",
  UPDATE_FAILURE: "FABRIC_UPDATE_FAILURE",

  DELETE_REQUEST: "FABRIC_DELETE_REQUEST",
  DELETE_SUCCESS: "FABRIC_DELETE_SUCCESS",
  DELETE_FAILURE: "FABRIC_DELETE_FAILURE",

  CLEAR: "FABRIC_CLEAR",
};
